import React from 'react';

const TrimContent = ({ text, maxLength }) => {
  return text 
    ? (text.length > maxLength 
        ? text.substring(0, maxLength) + '...' 
        : text)
    : 'None';
};

export default TrimContent;